"use client";

import Script from "next/script";

export default function AdtractionScript() {
  return (
    <>
      <Script
        id="adtraction-plugin-js"
        src="https://on.craftginclub.co.uk/jsTag?ap=1969032384"
        defer
      />
    </>
  );
}
